<template>
	<div class="home-page" @click="closeUserInfo">
		<div class="app-container">
			<div class="navi-bar">
				<div class="navi-bar-box">
					<div class="top">
						<div class="user-head-image">
							<head-image :name="userStore.userInfo.nickName" :size="38"
								:url="userStore.userInfo.headImageThumb" @click.native="showSettingDialog = true">
							</head-image>
							<!-- 新版本红点：App.vue 检测到 version.json 变更时亮起，点击刷新加载新版 -->
							<div v-if="newVersion" class="version-badge" title="发现新版本，点击更新"
								@click.stop="reloadToNewVersion"></div>
						</div>
						<div class="menu">
							<router-link class="link" v-bind:to="'/home/chat'">
								<div class="menu-item">
									<span class="icon iconfont icon-chat"></span>
									<div v-show="unreadCount > 0" class="unread-text">{{ unreadCount }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/friend'">
								<div class="menu-item">
									<span class="icon iconfont icon-friend"></span>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/group'">
								<div class="menu-item">
									<span class="icon iconfont icon-group" style="font-size: 28px"></span>
								</div>
							</router-link>
							<router-link v-if="userStore.isBizFinance" class="link" v-bind:to="'/home/finance'" title="财务统计">
								<div class="menu-item">
									<i class="el-icon-data-line" style="font-size: 26px"></i>
								</div>
							</router-link>
							<!-- 客情统计（财务汇总查看），与群内业务员填报不同，此入口必须保留 -->
							<router-link v-if="userStore.isBizFinance" class="link" v-bind:to="'/home/kq-stats'" title="客情统计">
								<div class="menu-item">
									<i class="el-icon-pie-chart" style="font-size: 26px"></i>
								</div>
							</router-link>
							<router-link v-if="userStore.isBizSales" class="link" v-bind:to="'/home/my-customer'" title="我的客户">
								<div class="menu-item">
									<i class="el-icon-user-solid" style="font-size: 26px"></i>
								</div>
							</router-link>
							<router-link v-if="configStore.features.report" class="link" v-bind:to="'/home/report-share'" title="报告分享">
							<div class="menu-item">
								<i class="el-icon-share" style="font-size: 26px"></i>
							</div>
						</router-link>
						<!-- 行情看板入口隐藏(2026-08-25 用户确认: IM内不要看板,用官网版; 路由与quote-board.html保留供官网使用) -->
						<!-- <router-link class="link" v-bind:to="'/home/quote'" title="行情看板">
							<div class="menu-item">
								<i class="el-icon-data-analysis" style="font-size: 26px"></i>
							</div>
						</router-link> -->
						</div>
					</div>

					<div class="botoom">
						<div class="bottom-item" @click="openAppDownload" title="APP下载">
							<i class="el-icon-download"></i>
						</div>
						<div class="bottom-item" @click="onLock()" title="锁屏">
							<i class="el-icon-lock"></i>
						</div>
						<div class="bottom-item" @click="showSetting">
							<span class="icon iconfont icon-setting" style="font-size: 20px"></span>
						</div>
					</div>
				</div>
			</div>
			<div class="content-box">
				<router-view></router-view>
			</div>
			<setting :visible="showSettingDialog" @close="closeSetting()" @logout="onExit()"></setting>
			<user-info ref="userInfo"></user-info>
			<full-image ref="fullImage"></full-image>
			<!-- 音视频通话已下线(2026-08-02 决策: 仅保留 iOS/安卓 App 间通话), 组件不挂载, web端来电静默 -->
			<!-- <rtc-private-video ref="rtcPrivateVideo"></rtc-private-video> -->
			<!-- <rtc-group-video ref="rtcGroupVideo"></rtc-group-video> -->
			<lock-screen @exit="onExit()"></lock-screen>
			<app-download ref="appDownload"></app-download>
			<!-- 断网保护遮罩：断网时丢弃内存密钥，本地缓存不可读，并阻断界面 -->
			<transition name="offline-fade">
				<div class="offline-mask" v-if="offline">
					<div class="offline-panel">
						<i class="el-icon-warning-outline offline-icon"></i>
						<div class="offline-title">网络已断开</div>
						<div class="offline-tip">为保护聊天记录安全，断网状态下无法查看聊天内容。<br />连接恢复后将自动解锁。</div>
						<div class="offline-reconnect">正在尝试重新连接...</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import HeadImage from '../components/common/HeadImage.vue';
import Setting from '../components/setting/Setting.vue';
import UserInfo from '../components/common/UserInfo.vue';
import FullImage from '../components/common/FullImage.vue';
import RtcPrivateVideo from '../components/rtc/RtcPrivateVideo.vue';
import RtcPrivateAcceptor from '../components/rtc/RtcPrivateAcceptor.vue';
import RtcGroupVideo from '../components/rtc/RtcGroupVideo.vue';
import LockScreen from '../components/common/LockScreen.vue';
import AppDownload from '../components/common/AppDownload.vue';
import { clearLoginSession } from '../api/auth.js';
import { hasLockPassword, getIdleMinutes, syncLockFromServer } from '../api/lock.js';
import dataCrypto from '../api/dataCrypto.js';
import { listFavorites } from '../api/favoriteApi.js';

export default {
	components: {
		HeadImage,
		Setting,
		UserInfo,
		FullImage,
		RtcPrivateVideo,
		RtcPrivateAcceptor,
		RtcGroupVideo,
		LockScreen,
		AppDownload
	},
	data() {
		return {
			showSettingDialog: false,
			lastPlayAudioTime: new Date().getTime() - 1000,
			reconnecting: false,
			offline: false,
			privateMessagesBuffer: [],
			groupMessagesBuffer: [],
			idleTimer: null,
			idleLimit: 60 * 1000, // 默认1分钟, mounted时从用户设置读取
			newVersion: '' // 检测到的新版本号(非空则头像亮红点)
		}
	},
	methods: {
		openAppDownload() {
			this.$refs.appDownload.open();
		},
		// 点击新版本红点：带版本参数强制重拉 index.html，避开 HTTP 缓存拿旧版
		reloadToNewVersion() {
			window.location.replace(window.location.pathname + '?_v=' + this.newVersion + window.location.hash);
		},
		init() {
			this.$eventBus.$on('openPrivateVideo', (rctInfo) => {
				// 进入单人视频通话(web端已下线, 组件未挂载时静默)
				this.$refs.rtcPrivateVideo && this.$refs.rtcPrivateVideo.open(rctInfo);
			});
			this.$eventBus.$on('openGroupVideo', (rctInfo) => {
				// 进入多人视频通话(web端已下线, 组件未挂载时静默)
				this.$refs.rtcGroupVideo && this.$refs.rtcGroupVideo.open(rctInfo);
			});
			this.$eventBus.$on('openUserInfo', (user, pos) => {
				// 打开用户卡片
				console.log("this.$refs.userInfo:",this.$refs.userInfo)
				this.$refs.userInfo.open(user, pos);
			});
			this.$eventBus.$on('openFullImage', (url, urls) => {
				// 图片全屏(支持画廊浏览)
				this.$refs.fullImage.open(url, urls);
			});
			this.$eventBus.$on('openFullVideo', url => {
				// 视频全屏播放
				this.$refs.fullImage.openVideo(url);
			});
			this.loadStore().then(() => {
				// ws初始化
				this.$wsApi.connect(process.env.VUE_APP_WS_URL, sessionStorage.getItem("accessToken"));
				this.$wsApi.onConnect(() => {
					if (this.reconnecting) {
						this.onReconnectWs();
					} else {
						// 加载离线消息
						this.pullOfflineMessage();
					}
				});
				this.$wsApi.onMessage((cmd, message) => {
					if (cmd == 2) {
						// 关闭ws
						this.$wsApi.close(3000)
						// 异地登录，强制下线
						this.$alert("您已在其他地方登录，将被强制下线", "强制下线通知", {
							confirmButtonText: '确定',
							callback: action => {
								location.href = location.pathname + "#/login";
							}
						});
					} else if (cmd == 3) {
						if (this.chatStore.loading) {
							// 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
							this.privateMessagesBuffer.push(message);
						} else {
							// 插入私聊消息
							this.handlePrivateMessage(message);
						}
					} else if (cmd == 4) {
						if (this.chatStore.loading) {
							// 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
							this.groupMessagesBuffer.push(message);
						} else {
							// 插入群聊消息
							this.handleGroupMessage(message);
						}
					} else if (cmd == 5) {
						// 处理系统消息
						this.handleSystemMessage(message);
					}
				});
				this.$wsApi.onClose((e) => {
					if (e.code != 3000) {
						// 非主动关闭：视为断网，立即启动断网保护
						// 锁屏期间不触发断网保护(锁屏时已清理密钥和会话，避免覆盖解锁流程)
						if (!this.configStore.locked) {
							this.enterOffline();
						}
						// 断线重连
						if (!this.reconnecting) {
							this.reconnectWs();
						}
					}
				});
			}).catch((e) => {
				console.log("初始化失败", e);
			})
		},
		reconnectWs() {
			// 记录标志
			this.reconnecting = true;
			// 重新加载一次个人信息，目的是为了保证网络已经正常且token有效
			this.userStore.loadUser().then(() => {
				// 断线重连
				this.$message.error("连接断开，正在尝试重新连接...");
				this.$wsApi.reconnect(process.env.VUE_APP_WS_URL, sessionStorage.getItem(
					"accessToken"));
			}).catch(() => {
				// 10s后重试
				setTimeout(() => this.reconnectWs(), 10000)
			})
		},
		onReconnectWs() {
			// 重连成功
			this.reconnecting = false;
			// 重连成功：重新拉取内存密钥并解除断网遮罩
			this.loadDataKey().then(() => {
				// 重新加载群和好友
				const promises = [];
				promises.push(this.friendStore.loadFriend());
				promises.push(this.groupStore.loadGroup());
				promises.push(this.configStore.loadConfig());
			promises.push(this.configStore.loadFeatures());
				Promise.all(promises).then(async () => {
					// 根据服务端远程清理状态处理本地缓存
					await this.applyWipeState();
					// 解除断网遮罩
					this.exitOffline();
					// 加载离线消息
					this.pullOfflineMessage();
					this.$message.success("重新连接成功");
				}).catch(() => {
					this.$message.error("初始化失败");
					this.onExit();
				});
			}).catch(() => {
				this.$message.error("获取安全密钥失败");
				this.onExit();
			});
		},
		// 进入断网保护：丢弃内存密钥（本地密文立即不可读）+ 清内存会话 + 显示遮罩
		enterOffline() {
			if (this.offline) {
				return;
			}
			// 锁屏期间不重复清理(锁屏时已清理，避免覆盖解锁流程设置的密钥)
			if (this.configStore.locked) {
				return;
			}
			// 商用版关闭断网保护：网络不稳定时“网络已断开”遮罩反复弹出影响使用，
			// 关闭后不显示遮罩、不丢弃密钥，仅后台静默重连(2026-08-30 商用需求)
			if (!this.configStore.features.offlineLock) {
				return;
			}
			this.offline = true;
			// 丢弃内存密钥，本地缓存即时不可解密
			dataCrypto.clearKey();
			// 清空内存中的会话/消息，防止已渲染的明文残留在页面
			try {
				this.chatStore.clear();
			} catch (e) {
				console.log("清理内存会话失败", e);
			}
		},
		// 退出断网保护（密钥已重新拉取后调用）
		exitOffline() {
			this.offline = false;
		},
		// 联网后拉取本地数据密钥（仅存内存，用于解密本地缓存）
		// 注意：密钥加载失败不能阻断整个应用（否则会卡在“消息接收中”）。
		// 本地缓存加密是纵深防御增强，非核心链路；失败时降级为不加密并告警。
		async loadDataKey() {
			try {
				const key = await this.$http({
					url: '/user/dataKey',
					method: 'get'
				});
				const ok = await dataCrypto.setKeyFromBase64(key);
				if (!ok) {
					console.warn('本地数据密钥导入失败：当前环境可能不支持 WebCrypto（需 HTTPS 安全上下文），本地缓存加密已跳过');
					if (!dataCrypto.isCryptoAvailable() && !this._cryptoWarned) {
						this._cryptoWarned = true;
						this.$message.warning('当前环境不支持本地加密，聊天记录将以未加密方式缓存');
					}
				}
			} catch (e) {
				// 网络异常等：不阻断应用启动，本地已有密文在无密钥时显示占位符
				console.warn('拉取本地数据密钥失败，本地缓存加密已跳过', e);
			}
		},
		// 根据服务端远程清理状态处理本地缓存
		async applyWipeState() {
			const appliedKey = 'chatWipeAppliedSeq_' + this.userStore.userInfo.id;
			const appliedSeq = Number(localStorage.getItem(appliedKey) || 0);
			const serverSeq = this.configStore.chatWipeSeq || 0;
			// 注意(2026-08-12 修复)：脚本只 wipe 不 restore，chatWiped 全天为 true，
			// 按 wiped=true 无条件清本地会把白天积累的消息在刷新/重连时清光。
			// 正确语义：仅当 seq 变化(发生过新清理且未应用)才清本地。
			if (serverSeq > appliedSeq) {
				await this.$db.clearChatData();
				this.chatStore.clear();
				localStorage.setItem(appliedKey, String(serverSeq));
			}
		},
		// 部署自愈(2026-08-12)：开着的老页面内存里跑的是旧前端(旧清理逻辑会每次重连清消息)，
		// 轮询 version.json，发现新部署自动刷新加载新包，避免"发版后老页面全天跑旧逻辑"。
		startVersionWatch() {
			const fetchV = () => fetch('/version.json?_=' + Date.now(), { cache: 'no-store' })
				.then(r => (r.ok ? r.json() : null)).catch(() => null);
			fetchV().then(v0 => {
				if (!v0 || !v0.version) return;
				this._bootVersion = String(v0.version);
				if (this._versionTimer) clearInterval(this._versionTimer);
				this._versionTimer = setInterval(() => {
					fetchV().then(v => {
						if (v && v.version && String(v.version) !== this._bootVersion) {
							clearInterval(this._versionTimer);
							this.$message.success('检测到新版本部署，正在自动刷新…');
							setTimeout(() => location.reload(), 800);
						}
					});
				}, 60000);
			});
		},
		async loadStore() {
			await this.userStore.loadUser();
			// 用服务端锁屏设置校准本地，保证手机端与Web端锁屏设置一致
			syncLockFromServer(this.userStore.userInfo);
			// 更新闲置锁屏时间（mounted时用户信息未加载，读到的是默认值）
			this.idleLimit = getIdleMinutes(this.userStore.userInfo.id) * 60 * 1000;
			// 加载财务业务协作角色(尽力而为，不阻断)
			await this.userStore.loadBizRole();
			await this.$db.open(this.userStore.userInfo.id);
			// 恢复持久化的锁屏状态（防止刷新绕过锁屏）
			this.configStore.restoreLock();
			// 联网后先拉取本地数据密钥（仅内存），后续才能解密本地缓存
			await this.loadDataKey();
			// 加载好友要在加载会话前面，否则好友在线状态不显示
			await this.friendStore.loadFriend();
			const promises = [];
			promises.push(this.groupStore.loadGroup());
			promises.push(this.configStore.loadConfig());
			promises.push(this.configStore.loadFeatures());
			await Promise.all(promises);
			// 根据服务端远程清理状态处理本地缓存（需在加载会话前）
			await this.applyWipeState();
			const result = await this.chatStore.loadConversations();
			// 恢复刷新前打开的会话窗口
			this.chatStore.restoreActive();
			// 若启动时即处于锁屏，加载完成后丢弃内存密钥，锁屏期间本地缓存不可再解密
			if (this.configStore.locked) {
				dataCrypto.clearKey();
			}
			return result;
		},
		unloadStore() {
			this.friendStore.clear();
			this.groupStore.clear();
			this.chatStore.clear();
			this.userStore.clear();
		},
		pullOfflineMessage() {
			let timeStamp = new Date().getTime();
			this.chatStore.setLoading(true);
			const promises = [];
			const maxPrivateMessageId = this.chatStore.findMaxMessageId(this.$enums.CONVERSATION_TYPE.PRIVATE);
			const maxGroupMessageId = this.chatStore.findMaxMessageId(this.$enums.CONVERSATION_TYPE.GROUP);
			// 循环分页拉取: 只要服务器没清理, 离线期间的消息全部拉回(旧版只拉最新10条会丢)
			promises.push(this.pullPaged((maxId) => this.pullPrivateOfflineMessage(maxPrivateMessageId, maxId)));
			promises.push(this.pullPaged((maxId) => this.pullGroupOfflineMessage(maxGroupMessageId, maxId)));
			Promise.all(promises).then(async (messages) => {
				// 传输层解密: 服务器返回的离线消息content是加密的
				await dataCrypto.decryptMessages(messages[0]);
				await dataCrypto.decryptMessages(messages[1]);
				// 处理离线消息
				await this.handlePrivateOfflineMessage(messages[0]);
				await this.handleGroupOfflineMessage(messages[1]);
				// 处理缓冲区收到的实时消息
				for (const m of this.privateMessagesBuffer) {
					await this.handlePrivateMessage(m);
				}
				for (const m of this.groupMessagesBuffer) {
					await this.handleGroupMessage(m);
				}
				// 清空缓冲区
				this.privateMessagesBuffer = [];
				this.groupMessagesBuffer = [];
				// 跨端已读对账: 清掉"别端已读、本端离线错过同步"的残留红点(尽力而为,不阻断启动)
				this.reconcileUnread().catch(() => {});
				// 关闭加载离线标记
				this.chatStore.setLoading(false);
				// 打印耗时
				let size = messages[0].length + messages[1].length;
				let time = new Date().getTime() - timeStamp;
				console.log("加载离线消息耗时:", time, ",消息数量:", size)
			}).catch((e) => {
				console.log(e)
				this.$message.error("拉取离线消息失败");
				this.onExit();
			})
		},
		// 跨端已读对账: 向服务器批量查询已读位置,本端会话已读位置>=本地最大消息id时清零未读,
		// 解决"在别的终端已读、本端离线错过READ同步"导致的残留红点
		async reconcileUnread() {
			const convs = this.chatStore.conversations.filter(c =>
				(c.unreadCount || 0) > 0 && (c.maxMessageId || 0) > 0);
			if (!convs.length) {
				return;
			}
			const friendIds = convs.filter(c => c.type == this.$enums.CONVERSATION_TYPE.PRIVATE).map(c => c.targetId);
			const groupIds = convs.filter(c => c.type == this.$enums.CONVERSATION_TYPE.GROUP).map(c => c.targetId);
			let pPos = {};
			let gPos = {};
			if (friendIds.length) {
				pPos = await this.$http({
					url: '/message/private/readedPositions',
					method: 'post',
					data: friendIds
				}) || {};
			}
			if (groupIds.length) {
				gPos = await this.$http({
					url: '/message/group/readedPositions',
					method: 'post',
					data: groupIds
				}) || {};
			}
			for (const c of convs) {
				const pos = c.type == this.$enums.CONVERSATION_TYPE.PRIVATE ? pPos[c.targetId] : gPos[c.targetId];
				if (pos != null && Number(pos) >= c.maxMessageId) {
					await this.chatStore.resetUnreadCount(c.key);
					await this.chatStore.resetAtMessage(c.key);
				}
			}
		},
		async handlePrivateOfflineMessage(messages) {
			if (!messages || !messages.length) {
				return;
			}
			// 会话信息
			const conversationMap = new Map();
			// 离线消息,map结构方便查询
			const messageMap = new Map(messages.map(m => [m.id, m]));
			// 处理过程中衍生的需要入库的事消息
			const tmpMessages = [];
			for (const m of messages) {
				// 标记这条消息是不是自己发的
				m.selfSend = m.sendId == this.mine.id;
				// 好友id: 服务端带convKey时优先按convKey归属会话(镜像消息的发送者可能不是会话两端,
				// 如芝麻接待会话中财务回复镜像进其他管理员的买家会话); 无convKey保持旧逻辑
				let friendId;
				if (m.convKey && String(m.convKey).includes('_')) {
					const ids = String(m.convKey).split('_').map(Number);
					friendId = ids.find(id => id != this.mine.id);
				}
				if (!friendId) {
					friendId = m.selfSend ? m.recvId : m.sendId;
				}
				// 标记消息所属会话id
				const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friendId);
				m.convKey = convKey;
				// 查询会话
				let conversation = conversationMap.get(friendId);
				if (!conversation) {
					// 查db
					conversation = await this.$db.findConversationByKey(convKey);
					if (!conversation) {
						// 创建新会话
						const friend = this.loadFriendInfo(friendId);
						conversation = {
							key: convKey,
							type: this.$enums.CONVERSATION_TYPE.PRIVATE,
							targetId: friend.id,
							showName: friend.nickName,
							headImage: friend.headImage,
							isDnd: friend.isDnd,
							isTop: false,
							lastContent: "",
							lastSendTime: new Date().getTime(),
							optTime: new Date().getTime(),
							unreadCount: 0,
							lastTimeTip: 0,
							maxMessageId: 0,
							minSeqNo: 0,
							maxSeqNo: 0,
							maxReadedId: 0
						}
					}
					conversationMap.set(friendId, conversation);
				}
				// 会话时间	
				conversation.lastSendTime = m.sendTime;
				conversation.optTime = m.sendTime;
				// 记录会话最大消息id
				conversation.maxMessageId = Math.max(conversation.maxMessageId, m.id)
				conversation.maxSeqNo = Math.max(conversation.maxSeqNo, m.seqNo)
				// 会话未读加1
				if (!m.selfSend && m.status != this.$enums.MESSAGE_STATUS.READED &&
					m.status != this.$enums.MESSAGE_STATUS.RECALL && m.type != this.$enums.MESSAGE_TYPE.TIP_TEXT) {
					conversation.unreadCount++;
				}
				// 撤回消息
				if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
					const recallMessageId = Number(JSON.parse(m.content).id);
					const recallMessageTip = JSON.parse(m.content).tip || '';
					let recallMessage = messageMap.get(recallMessageId);
					if (!recallMessage) {
						recallMessage = await this.$db.findMessageById(convKey, recallMessageId);
						if (!recallMessage) {
							continue;
						}
						tmpMessages.push(recallMessage);
					}
					// 把原消息改造成一条提示消息
					recallMessage.status = this.$enums.MESSAGE_STATUS.PENDING;
					recallMessage.content = recallMessageTip;
					recallMessage.type = this.$enums.MESSAGE_TYPE.TIP_TEXT
					// 会话提示语
					conversation.lastContent = this.$msgUtil.previewContent(recallMessage);
					conversation.sendNickName = "";
				} else {
					// 会话列表内容
					conversation.lastContent = this.$msgUtil.previewContent(m);
				}
			}
			// 批量保存会话和消息
			const conversations = Array.from(conversationMap.values());
			await this.$db.saveConversationAndMessage(conversations, messages.concat(tmpMessages));
			this.chatStore.append(conversations);
		},
		async handleGroupOfflineMessage(messages) {
			if (!messages || !messages.length) {
				return;
			}
			// 会话信息
			const conversationMap = new Map();
			// 离线消息,map结构方便查询
			const messageMap = new Map(messages.map(m => [m.id, m]));
			// 处理过程中衍生的需要入库的事消息
			const tmpMessages = [];
			for (const m of messages) {
				// 标记这条消息是不是自己发的
				m.selfSend = m.sendId == this.mine.id;
				// 好友id
				const groupId = m.groupId;
				// 标记消息所属会话id
				const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, groupId);
				m.convKey = convKey;
				// 查询会话
				let conversation = conversationMap.get(groupId);
				if (!conversation) {
					// 查db
					conversation = await this.$db.findConversationByKey(convKey);
					if (!conversation) {
						// 创建新会话
						const group = this.loadGroupInfo(groupId);
						conversation = {
							key: convKey,
							type: this.$enums.CONVERSATION_TYPE.GROUP,
							targetId: group.id,
							showName: group.showGroupName,
							headImage: group.headImageThumb,
							isDnd: group.isDnd,
							isTop: false,
							lastContent: "",
							lastSendTime: new Date().getTime(),
							optTime: new Date().getTime(),
							unreadCount: 0,
							atMe: false,
							atAll: false,
							lastAtMessageId: -1,
							lastTimeTip: 0,
							maxMessageId: 0,
							minSeqNo: 0,
							maxSeqNo: 0,
							maxReadedId: 0
						}
					}
					conversationMap.set(groupId, conversation);
				}
				// 会话时间	
				conversation.lastSendTime = m.sendTime;
				conversation.optTime = m.sendTime;
				// 记录会话最大消息id
				conversation.maxMessageId = Math.max(conversation.maxMessageId, m.id);
				conversation.maxSeqNo = Math.max(conversation.maxSeqNo, m.seqNo)
				// 会话未读加1
				if (!m.selfSend && m.status != this.$enums.MESSAGE_STATUS.READED &&
					m.status != this.$enums.MESSAGE_STATUS.RECALL && m.type != this.$enums.MESSAGE_TYPE.TIP_TEXT) {
					conversation.unreadCount++;
				}
				// 是否有人@我（已读、已撤回的消息不再设置）
				if (!m.selfSend && m.atUserIds && m.status != this.$enums.MESSAGE_STATUS.READED
					&& m.status != this.$enums.MESSAGE_STATUS.RECALL) {
					const userId = this.mine.id;
					if (m.atUserIds.indexOf(userId) >= 0) {
						conversation.atMe = true;
						conversation.lastAtMessageId = m.id;
					}
					if (m.atUserIds.indexOf(-1) >= 0) {
						conversation.atAll = true;
						conversation.lastAtMessageId = m.id;
					}
				}
				// 撤回消息
				if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
					const recallMessageId = Number(JSON.parse(m.content).id);
					const recallMessageTip = JSON.parse(m.content).tip || '';
					let recallMessage = messageMap.get(recallMessageId);
					if (!recallMessage) {
						recallMessage = await this.$db.findMessageById(convKey, recallMessageId);
						if (!recallMessage) {
							continue;
						}
						tmpMessages.push(recallMessage);
					}
					// 撤回的若是@我消息，清除标记
					if (conversation.lastAtMessageId == recallMessageId) {
						conversation.atMe = false;
						conversation.atAll = false;
						conversation.lastAtMessageId = -1;
					}
					// 改造成一条提示消息
					recallMessage.status = this.$enums.MESSAGE_STATUS.PENDING;
					recallMessage.content = recallMessageTip;
					recallMessage.type = this.$enums.MESSAGE_TYPE.TIP_TEXT
					// 会话提示语
					conversation.lastContent = this.$msgUtil.previewContent(recallMessage);
					conversation.sendNickName = "";
				} else {
					// 会话列表内容
					conversation.lastContent = this.$msgUtil.previewContent(m);
					// 其他成员发的消息显示发送昵称
					conversation.sendNickName = m.selfSend ? '' : m.sendNickName;
				}
			}
			const conversations = Array.from(conversationMap.values());
			await this.$db.saveConversationAndMessage(conversations, messages.concat(tmpMessages));
			this.chatStore.append(conversations);
		},
		pullPrivateOfflineMessage(minId, maxId) {
			let url = "/message/private/loadOfflineMessage?minId=" + minId;
			if (maxId) {
				url += "&maxId=" + maxId;
			}
			return this.$http({
				url: url
			})
		},
		pullGroupOfflineMessage(minId, maxId) {
			let url = "/message/group/loadOfflineMessage?minId=" + minId;
			if (maxId) {
				url += "&maxId=" + maxId;
			}
			return this.$http({
				url: url
			})
		},
		// 分页拉取离线消息: 服务端每页最多100条(降序), 满页则用本页最小id作为上界继续拉, 直到不满页=拉完
		pullPaged(fetcher) {
			const PAGE_SIZE = 100;
			const MAX_TOTAL = 5000;
			const all = [];
			const next = (maxId) => fetcher(maxId).then((batch) => {
				all.push(...(batch || []));
				if (!batch || batch.length < PAGE_SIZE || all.length >= MAX_TOTAL) {
					return all;
				}
				return next(Math.min(...batch.map((m) => m.id)));
			});
			return next(null);
		},
		async handlePrivateMessage(m) {
			// 传输层解密: WebSocket实时推送的消息content是加密的
			await dataCrypto.decryptMessage(m);
			// 标记这条消息是不是自己发的
			m.selfSend = m.sendId == this.mine.id;
			// 好友id: 服务端带convKey时优先按convKey归属会话(镜像消息的发送者可能不是会话两端,
			// 如芝麻接待会话中财务回复镜像进其他管理员的买家会话); 无convKey保持旧逻辑
			let friendId;
			if (m.convKey && String(m.convKey).includes('_')) {
				const ids = String(m.convKey).split('_').map(Number);
				friendId = ids.find(id => id != this.mine.id);
			}
			if (!friendId) {
				friendId = m.selfSend ? m.recvId : m.sendId;
			}
			// 会话信息
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friendId);
			// 消息已读处理，清空已读数量
			if (m.type == this.$enums.MESSAGE_TYPE.READED) {
				await this.chatStore.resetUnreadCount(convKey)
				return;
			}
			// 消息回执处理,更新对方已读位置
			if (m.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				const messageId = JSON.parse(m.content).id;
				await this.chatStore.readedMessage(convKey, messageId)
				return;
			}
			// 消息撤回
			if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
				await this.chatStore.recallMessage(convKey, m)
				return;
			}
			// 消息编辑
			if (m.type == this.$enums.MESSAGE_TYPE.EDIT) {
				await this.chatStore.editMessage(convKey, JSON.parse(m.content))
				return;
			}
			// 消息置顶变化
			if (m.type == this.$enums.MESSAGE_TYPE.PIN) {
				this.$eventBus.$emit("pinChanged", convKey);
				return;
			}
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
				this.friendStore.addFriend(JSON.parse(m.content));
				return;
			}
			// 删除好友
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
				this.friendStore.removeFriend(friendId);
				// 无感清理: 好友解除后私聊会话连同本地缓存一并移除
				if (this.chatStore.conversationMap.has(convKey)) {
					await this.chatStore.remove(convKey);
				}
				return;
			}
			// 好友在线状态
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_ONLINE) {
				this.friendStore.updateOnlineStatus(JSON.parse(m.content));
				return;
			}
			// 对好友设置免打扰
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_DND) {
				this.friendStore.setDnd(friendId, JSON.parse(m.content));
				await this.chatStore.setDnd(convKey, JSON.parse(m.content));
				return;
			}
			// 对方修改了昵称/头像：实时同步好友信息与会话展示
			if (m.type == this.$enums.MESSAGE_TYPE.FRIEND_INFO_CHANGE) {
				const info = JSON.parse(m.content);
				await this.friendStore.updateFriendInfo(info.id, info.nickName, info.headImage);
				await this.chatStore.updatePrivateConvInfo(info.id, info.nickName, info.headImage);
				return;
			}
			// 单人webrtc 信令
			if (this.$msgType.isRtcPrivate(m.type)) {
				this.$refs.rtcPrivateVideo.onRTCMessage(m)
				return;
			}
			// 消息插入
			if (this.$msgType.isNormal(m.type) || this.$msgType.isTip(m.type) || this.$msgType.isAction(m.type)) {
				const friend = this.loadFriendInfo(friendId);
				await this.insertPrivateMessage(friend, m);
			}
		},
		async insertPrivateMessage(friend, m) {
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id);
			const chatInfo = {
				type: this.$enums.CONVERSATION_TYPE.PRIVATE,
				targetId: friend.id,
				showName: friend.nickName,
				headImage: friend.headImage,
				isDnd: friend.isDnd
			};
			// 打开会话
			await this.chatStore.openChat(chatInfo);
			// 插入消息
			await this.chatStore.insertMessage(convKey, m);
			// 通知chat-box组件
			if (this.chatStore.isActive(convKey)) {
				this.$eventBus.$emit("newMessage", m);
			}
			// 播放提示音
			if (!friend.isDnd && !m.selfSend && this.$msgType.isNormal(m.type)
				&& m.status != this.$enums.MESSAGE_STATUS.READED) {
				this.playAudioTip();
				// 桌面通知：私聊标题=发送者昵称，正文=消息内容
				this.showDesktopNotification(friend.nickName, this.$msgUtil.previewContent(m), friend.headImage, convKey);
			}
		},
		async handleGroupMessage(m) {
			console.log("handleGroupMessage:", m)
			// 传输层解密: WebSocket实时推送的消息content是加密的
			await dataCrypto.decryptMessage(m);
			// 标记这条消息是不是自己发的
			m.selfSend = m.sendId == this.mine.id;
			// 会话信息
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, m.groupId);
			// 发送用户昵称优先显示好友备注的名字
			if (m.sendId && m.sendNickName) {
				const f = this.friendStore.findFriend(m.sendId);
				if (f && !f.deleted && f.remarkNickName) {
					m.sendNickName = f.remarkNickName;
				}
			}
			// 消息已读处理
			if (m.type == this.$enums.MESSAGE_TYPE.READED) {
				// 我已读对方的消息，清空已读数量
				await this.chatStore.resetUnreadCount(convKey)
				await this.chatStore.resetAtMessage(convKey)
				return;
			}
			// 消息回执处理
			if (m.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				// 更新消息已读人数
				const message = {
					localId: m.localId,
					readedCount: m.readedCount,
					receiptOk: m.receiptOk
				};
				await this.chatStore.updateMessage(convKey, message)
				return;
			}
			// 消息撤回
			if (m.type == this.$enums.MESSAGE_TYPE.RECALL) {
				await this.chatStore.recallMessage(convKey, m)
				return;
			}
			// 消息编辑
			if (m.type == this.$enums.MESSAGE_TYPE.EDIT) {
				await this.chatStore.editMessage(convKey, JSON.parse(m.content))
				return;
			}
			// 消息置顶变化
			if (m.type == this.$enums.MESSAGE_TYPE.PIN) {
				this.$eventBus.$emit("pinChanged", convKey);
				return;
			}
			// 新增群
			if (m.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
				this.groupStore.addGroup(JSON.parse(m.content));
				return;
			}
			// 删除群
			if (m.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
				this.groupStore.removeGroup(m.groupId);
				return;
			}
			// 对群设置免打扰
			if (m.type == this.$enums.MESSAGE_TYPE.GROUP_DND) {
				this.groupStore.setDnd(m.groupId, JSON.parse(m.content));
				await this.chatStore.setDnd(convKey, JSON.parse(m.content));
				return;
			}
			// 群视频信令
			if (this.$msgType.isRtcGroup(m.type)) {
				this.$nextTick(() => {
					this.$refs.rtcGroupVideo.onRTCMessage(m);
				})
				return;
			}
			// 插入群聊消息
			if (this.$msgType.isNormal(m.type) || this.$msgType.isTip(m.type) || this.$msgType.isAction(m.type)) {
				const group = this.loadGroupInfo(m.groupId);
				await this.insertGroupMessage(group, m);
			}
		},
		async insertGroupMessage(group, m) {
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.GROUP, group.id);
			const chatInfo = {
				type: this.$enums.CONVERSATION_TYPE.GROUP,
				targetId: group.id,
				showName: group.showGroupName,
				headImage: group.headImageThumb,
				isDnd: group.isDnd
			};
			// 打开会话
			await this.chatStore.openChat(chatInfo);
			// 插入消息
			await this.chatStore.insertMessage(convKey, m);
			// 通知chat-box组件
			if (this.chatStore.isActive(convKey)) {
				this.$eventBus.$emit("newMessage", m);
			}
			// 提示音和消息提醒
			if (!group.isDnd && !m.selfSend && !this.chatStore.loading && this.$msgType.isNormal(m.type)
				&& m.status != this.$enums.MESSAGE_STATUS.READED) {
				// 播放提示音
				this.playAudioTip();
				// 桌面通知：群聊标题=群名，正文=谁发了什么
				let body = (m.sendNickName ? m.sendNickName + '：' : '') + this.$msgUtil.previewContent(m);
				this.showDesktopNotification(group.showGroupName, body, group.headImageThumb, convKey);
			}
		},
		async handleSystemMessage(msg) {
			// 用户被封禁
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
				this.$wsApi.close(3000);
				this.$alert("您的账号已被管理员封禁,原因:" + msg.content, "账号被封禁", {
					confirmButtonText: '确定',
					callback: () => {
						this.onExit();
					}
				});
				return;
			}
			// 远程清理：清空本地全部聊天记录缓存
			if (msg.type == this.$enums.MESSAGE_TYPE.CHAT_WIPE) {
				const seq = Number(msg.content || 0);
				const appliedKey = 'chatWipeAppliedSeq_' + this.userStore.userInfo.id;
				this.configStore.setConfig({ webrtc: this.configStore.webrtc, chatWiped: true, chatWipeSeq: seq });
				this.$db.clearChatData().then(() => {
					this.chatStore.clear();
					localStorage.setItem(appliedKey, String(seq));
					this.$message.warning("管理员已清空聊天记录");
				});
				return;
			}
			// 远程恢复：解除清理状态，重新拉取消息
			if (msg.type == this.$enums.MESSAGE_TYPE.CHAT_RESTORE) {
				const seq = Number(msg.content || 0);
				const appliedKey = 'chatWipeAppliedSeq_' + this.userStore.userInfo.id;
				this.configStore.setConfig({ webrtc: this.configStore.webrtc, chatWiped: false, chatWipeSeq: seq });
				localStorage.setItem(appliedKey, String(seq));
				// 服务端已恢复查询,重新拉取离线消息(本地为空,将全量拉取)
				if (!this.chatStore.loading) {
					this.pullOfflineMessage();
				}
				this.$message.success("聊天记录已恢复");
				return;
			}
			// 消息收藏变化(多端同步)
			if (msg.type == this.$enums.MESSAGE_TYPE.FAVORITE) {
				try {
					const data = JSON.parse(msg.content);
					// 通知当前会话刷新收藏状态
					this.$eventBus.$emit("favoriteChanged", data);
				} catch (e) {
					// ignore parse error
				}
				return;
			}
			// 消息定时清理通知
			// 保留当天和昨天的消息,超过的清理;收藏消息不清理;会话列表保留(锚点)
			if (msg.type == this.$enums.MESSAGE_TYPE.MESSAGE_CLEANUP) {
				try {
					let content = JSON.parse(msg.content);
					let retentionDays = content.retentionDays || 2;
					await this.cleanupLocalMessages(retentionDays);
				} catch (e) {
					console.warn('[消息清理] 处理清理通知失败:', e);
				}
				return;
			}
		},
	// 清理本地IndexedDB中超过保留天数的消息(收藏消息不清理)
	async cleanupLocalMessages(retentionDays) {
		try {
			const threshold = Date.now() - retentionDays * 24 * 60 * 60 * 1000;
			// 先拉取当前用户的所有收藏消息ID,清理时排除
			let favoriteIds = [];
			try {
				const res = await listFavorites();
				if (res && res.length) {
					favoriteIds = res.map(f => f.messageId);
				}
			} catch (e) {
				console.warn('[消息清理] 获取收藏列表失败,跳过本地清理以保护收藏消息', e);
				return;
			}
			// 清理本地数据库中过期的消息记录(排除收藏)
			if (this.$db && this.$db.cleanupOldMessages) {
				await this.$db.cleanupOldMessages(threshold, favoriteIds);
			}
			console.log('[消息清理] 本地消息清理完成,保留天数:', retentionDays, '排除收藏:', favoriteIds.length);
		} catch (e) {
			console.warn('[消息清理] 本地清理失败:', e);
		}
	},
		closeUserInfo() {
			this.$refs.userInfo.close();
		},
		onLock() {
			// 未设置锁屏密码，引导去设置
			if (!hasLockPassword(this.userStore.userInfo.id)) {
				this.$confirm('你还没有设置锁屏密码，是否现在去设置？', '未设置锁屏密码', {
					confirmButtonText: '去设置',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.showSettingDialog = true;
				}).catch(() => { });
				return;
			}
			this.configStore.setLocked(true);
		},
		resetIdleTimer() {
			if (this.idleTimer) {
				clearTimeout(this.idleTimer);
			}
			// 已锁屏时不再计时
			if (this.configStore.locked) {
				return;
			}
			this.idleTimer = setTimeout(() => {
				// 到点后：设置了锁屏密码才自动锁
				if (hasLockPassword(this.userStore.userInfo.id) && !this.configStore.locked) {
					this.configStore.setLocked(true);
				}
			}, this.idleLimit);
		},
		setupIdleListener() {
			this._onUserActive = () => this.resetIdleTimer();
			['mousemove', 'mousedown', 'keydown', 'touchstart', 'wheel'].forEach(evt => {
				window.addEventListener(evt, this._onUserActive, { passive: true });
			});
			this.resetIdleTimer();
		},
		removeIdleListener() {
			if (this._onUserActive) {
				['mousemove', 'mousedown', 'keydown', 'touchstart', 'wheel'].forEach(evt => {
					window.removeEventListener(evt, this._onUserActive);
				});
			}
			if (this.idleTimer) {
				clearTimeout(this.idleTimer);
			}
		},
		onExit() {
			console.log("onExit")
			// 登出即丢弃内存密钥
			dataCrypto.clearKey();
			this.unloadStore();
			this.$wsApi.close(3000);
			clearLoginSession(true);
			this.$elm.setTitleTip("");
			this.$db.close();
			location.href = location.pathname + "#/login";
		},
		playAudioTip() {
			// 防止过于密集播放
			if (new Date().getTime() - this.lastPlayAudioTime > 1000) {
				this.lastPlayAudioTime = new Date().getTime();
				let audio = new Audio();
				let url = require(`@/assets/audio/tip.mp3`);
				audio.src = url;
				audio.play();
			}

		},
		showDesktopNotification(title, body, icon, tag) {
			// 未开启桌面通知开关则不提醒
			if (localStorage.getItem("desktopNotification") != "true") {
				return;
			}
			// 浏览器不支持或未授权则不提醒
			if (!("Notification" in window) || Notification.permission != "granted") {
				return;
			}
			// 页面处于可见状态时不打扰
			if (document.visibilityState == "visible") {
				return;
			}
			// 洪水消息处理：同一会话在冷却窗口内的多条消息聚合为一条，避免弹窗轰炸
			const key = tag || title || "default";
			const COOLDOWN = 4000; // 冷却窗口 4 秒
			if (!this._notifyState) {
				this._notifyState = {};
			}
			const st = this._notifyState[key];
			if (st && st.timer) {
				// 冷却期内：只累计数量并记录最新内容，暂不弹窗
				st.count++;
				st.title = title;
				st.body = body;
				st.icon = icon;
				return;
			}
			// 冷却期外：立即弹一条，并开启冷却计时
			this._fireNotification(title, body, icon, key);
			this._notifyState[key] = {
				count: 1,
				title: title,
				body: body,
				icon: icon,
				timer: setTimeout(() => {
					const s = this._notifyState[key];
					this._notifyState[key] = null;
					// 冷却期内又累计了多条，补弹一条聚合提醒（相同 tag 会替换旧通知）
					if (s && s.count > 1) {
						this._fireNotification(s.title, `共 ${s.count} 条新消息，最新：${s.body}`, s.icon, key);
					}
				}, COOLDOWN)
			};
		},
		_fireNotification(title, body, icon, tag) {
			try {
				const notification = new Notification(title || "新消息", {
					body: body || "",
					icon: icon || "",
					tag: tag || undefined // 同一会话用相同 tag，新通知替换旧通知，不堆叠
				});
				notification.onclick = () => {
					window.focus();
					notification.close();
				};
				// 5秒后自动关闭
				setTimeout(() => notification.close(), 5000);
			} catch (e) {
				console.log("桌面通知失败", e);
			}
		},
		showSetting() {
			this.showSettingDialog = true;
		},
		closeSetting() {
			this.showSettingDialog = false;
		},
		loadFriendInfo(id) {
			let friend = this.friendStore.findFriend(id);
			if (!friend) {
				friend = {
					id: id,
					nickName: "未知用户",
					headImage: ""
				}
			}
			return friend;
		},
		loadGroupInfo(id) {
			let group = this.groupStore.findGroup(id);
			if (!group) {
				group = {
					id: id,
					showGroupName: "未知群聊",
					headImageThumb: ""
				}
			}
			return group;
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		unreadCount() {
			let unreadCount = 0;
			const conversations = this.chatStore.conversations;
			conversations.forEach((conv) => {
				if (conv.isDnd) {
					return;
				}
				// 与会话列表展示口径对齐(Chat.vue isKept): 好友关系已解除(删除好友/影子买家解绑)的私聊
				// 不在列表展示, 若仍计入角标, 顶栏会挂一个无对应会话、永远点不掉的幽灵红点。
				// 典型场景: 解绑那一刻Web离线没收到FRIEND_DEL无感清理, 旧会话未读残留在本地缓存。
				if (this.$enums.CONVERSATION_TYPE.PRIVATE == conv.type) {
					const friend = this.friendStore.findFriend(conv.targetId);
					if (!friend || friend.deleted) {
						return;
					}
				}
				unreadCount += conv.unreadCount
			})
			return unreadCount;
		},
	},
	watch: {
		unreadCount: {
			handler(newCount, oldCount) {
				let tip = newCount > 0 ? `${newCount}条未读` : "";
				this.$elm.setTitleTip(tip);
			},
			immediate: true
		},
		// 锁屏加固：锁屏即丢弃内存密钥与已加载会话，解锁后重新联网拉取密钥并刷新
		'configStore.locked'(locked, old) {
			if (locked) {
				dataCrypto.clearKey();
				try {
					this.chatStore.clear();
				} catch (e) {
					console.log('锁屏清理内存会话失败', e);
				}
			} else if (old === true) {
				// 真正的“锁定→解锁”才需重新拉密钥并同步
				this.loadDataKey()
					.then(() => {
						// 密钥未就绪时短暂等待重试一次(避免网络波动导致密钥未加载)
						if (!dataCrypto.hasKey()) {
							return new Promise(r => setTimeout(r, 1500)).then(() => this.loadDataKey());
						}
					})
					.then(() => this.chatStore.loadConversations())
					.then(() => this.pullOfflineMessage())
					.catch(() => {
						this.$message.error('解锁后同步失败，请检查网络连接');
					});
			}
		}
	},
	mounted() {
		// 应用已保存的主题(黑夜模式)
		this.configStore.initTheme();
		// 新版本红点：监听 App.vue 版本检测结果; 加载时若已有未应用的新版本标记也直接亮
		this.$eventBus.$on('new-version', (v) => { this.newVersion = v; });
		const nv = sessionStorage.getItem('imNewVersion');
		// 只有标记的版本确实比当前新才亮红点(版本号是 Date.now() 可数值比较);
		// 防止连续发版后残留的旧标记导致 nv!==cur 永远亮红点刷新不灭
		if (nv && Number(nv) > Number(process.env.VUE_APP_BUILD_VERSION)) {
			this.newVersion = nv;
		}
		this.init();
		// 读取用户自定义锁屏闲置时间(分钟), 未设置默认1分钟
		this.idleLimit = getIdleMinutes(this.userStore.userInfo.id) * 60 * 1000;
		// 启动闲置自动锁屏监听
		this.setupIdleListener();
	},
	unmounted() {
		this.$wsApi.close();
		this.removeIdleListener();
	}
}
</script>

<style scoped lang="scss">
.home-page {
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	overflow: hidden;
	background: var(--im-color-primary-light-9);

	.app-container {
		// 2026-08-12: 取消缩小/放大聊天区域功能, 固定全屏最大化
		width: 100vw;
		height: 100vh;
		display: flex;
		min-width: 970px;
		position: absolute;
		overflow: hidden;
	}

	.navi-bar {
		--icon-font-size: 22px;
		--width: 70px;
		width: var(--width);
		background: linear-gradient(180deg, var(--im-color-primary-light-1) 0%, var(--im-color-primary-light-2) 100%);
		padding-top: 25px;
		position: relative;
		box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
		// 窗口变矮时功能区可上下滚动, 底部图标不再被挡住(隐藏滚动条保持美观)
		overflow-y: auto;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}

		.navi-bar-box {
			min-height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.botoom {
				margin-bottom: 25px;
			}
		}

		.user-head-image {
			display: flex;
			justify-content: center;
			margin-bottom: 10px;
			position: relative;

			// 新版本红点(呼吸闪烁)
			.version-badge {
				position: absolute;
				top: -2px;
				right: calc(50% - 26px);
				width: 12px;
				height: 12px;
				border-radius: 50%;
				background: #f56c6c;
				box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.85);
				cursor: pointer;
				z-index: 10;
				animation: version-blink 1.2s ease-in-out infinite;
			}

			@keyframes version-blink {

				0%,
				100% {
					opacity: 1;
					transform: scale(1);
				}

				50% {
					opacity: 0.35;
					transform: scale(0.85);
				}
			}

			// 头像容器样式，参考新版本
			:deep(.head-image) {
				border: 3px solid rgba(255, 255, 255, 0.2);
				border-radius: 50%;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
				transition: all 0.3s ease;

				&:hover {
					border-color: rgba(255, 255, 255, 0.4);
					transform: scale(1.05);
					box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
				}
			}
		}

		.menu {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;
			flex-wrap: wrap;
			margin-top: 25px;
			gap: 8px;

			.link {
				text-decoration: none;
				display: flex;
				justify-content: center;
			}

			.router-link-active .menu-item {
				color: white;
				background: linear-gradient(135deg,
						var(--im-color-primary-light-2) 0%,
						var(--im-color-primary) 100%);
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
				transform: translateX(2px);

				&::before {
					opacity: 1;
					transform: scale(1);
				}
			}

			.link:not(.router-link-active) .menu-item:hover {
				background: linear-gradient(135deg,
						var(--im-color-primary) 0%,
						var(--im-color-primary-light-2) 100%);
				transform: scale(1.08) translateX(2px);
				box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
				color: white;
			}

			.menu-item {
				position: relative;
				color: rgba(255, 255, 255, 0.8);
				width: 50px;
				height: 50px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 10px;
				border-radius: 12px;
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				cursor: pointer;

				// 左侧选中指示条
				&::before {
					content: '';
					position: absolute;
					left: -5px;
					width: 3px;
					height: 20px;
					background: white;
					border-radius: 2px;
					opacity: 0;
					transition: all 0.3s ease;
				}

				.icon {
					font-size: var(--icon-font-size);
					transition: all 0.3s ease;
				}

				.unread-text {
					position: absolute;
					background: var(--im-color-danger);
					left: 32px;
					top: 3px;
					color: white;
					border-radius: 10px;
					padding: 1px 6px;
					font-size: 10px;
					font-weight: 600;
					text-align: center;
					white-space: nowrap;
					border: 1px solid rgba(255, 255, 255, 0.9);
					box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
					min-width: 16px;
					height: 16px;
					display: flex;
					align-items: center;
					justify-content: center;
					z-index: 1;
				}
			}
		}

		.bottom-item {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 45px;
			width: 100%;
			cursor: pointer;
			color: rgba(255, 255, 255, 0.7);
			font-size: var(--icon-font-size);
			border-radius: 8px;
			margin: 4px 0;
			transition: all 0.3s ease;
			position: relative;

			.icon {
				font-size: var(--icon-font-size);
				transition: all 0.3s ease;
			}

			&:hover {
				color: white;
				background: rgba(255, 255, 255, 0.1);
				transform: scale(1.05);

				.icon {
					transform: scale(1.1);
				}
			}

			&:active {
				transform: scale(0.95);
			}
		}
	}

	.content-box {
		flex: 1;
		// flex 子项默认 min-width:auto 不能收缩到内容以下,长消息会把聊天列撑出视口,
		// 加 min-width:0 + overflow:hidden 让聊天区始终受视口约束、不横向溢出屏幕。
		min-width: 0;
		overflow: hidden;
		padding: 0;
		background-color: #fff;
		text-align: center;
	}
}

// 断网保护遮罩
.offline-mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 10000;
	display: flex;
	justify-content: center;
	align-items: center;
	background: linear-gradient(135deg, #1f2233 0%, #12131c 100%);
	backdrop-filter: blur(8px);

	.offline-panel {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 48px 40px;
		border-radius: 16px;
		background: rgba(255, 255, 255, 0.06);
		box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
		width: 360px;
		text-align: center;

		.offline-icon {
			font-size: 52px;
			color: #ffb74d;
		}

		.offline-title {
			margin-top: 18px;
			font-size: 20px;
			font-weight: 600;
			color: #fff;
		}

		.offline-tip {
			margin-top: 12px;
			font-size: 13px;
			line-height: 1.6;
			color: rgba(255, 255, 255, 0.65);
		}

		.offline-reconnect {
			margin-top: 18px;
			font-size: 12px;
			color: rgba(255, 255, 255, 0.45);
		}
	}
}

.offline-fade-enter-active,
.offline-fade-leave-active {
	transition: opacity 0.25s;
}

.offline-fade-enter,
.offline-fade-leave-to {
	opacity: 0;
}
</style>